import CategoriesRegistration from './CategoriesRegistration';

export default CategoriesRegistration;
